import { createFileRoute } from '@tanstack/react-router'
import { ResumeCollectionPage } from '@/features/resume-share/collection-page'

export const Route = createFileRoute('/share/collection/$token')({
  component: CollectionRoute,
})

function CollectionRoute() {
  const { token } = Route.useParams()
  return <ResumeCollectionPage token={token} />
}
